"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentIconColor = void 0;
var _color = _interopRequireDefault(require("../styles/color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var getContentIconColor = function getContentIconColor(contentType) {
  var contentIcon = null;
  var circleColor = null;
  if (contentType === 'ARRAY') {
    var colorArray = [_color["default"].info, _color["default"].danger, _color["default"].lightBlue, _color["default"].lightPurple, _color["default"].disabled, _color["default"].burntUmber, _color["default"].magenta, _color["default"].success, _color["default"].warning, _color["default"].orange, _color["default"].blue];
    return colorArray;
  } else {
    switch (contentType) {
      case 'CONTENT_WEB':
        circleColor = _color["default"].info;
        contentIcon = 'fileExport';
        break;
      case 'CONTENT_PDF':
        circleColor = _color["default"].danger;
        contentIcon = 'filePdf';
        break;
      case 'CONTENT_RICH_TEXT':
        circleColor = _color["default"].magenta;
        contentIcon = 'fileAlt';
        break;
      case 'CONTENT_IMAGE':
        circleColor = _color["default"].warning;
        contentIcon = 'fileImage';
        break;
      case 'CONTENT_VIDEO':
        circleColor = _color["default"].lightBlue;
        contentIcon = 'video';
        break;
      case 'CONTENT_AUDIO':
        circleColor = _color["default"].lightPurple;
        contentIcon = 'fileAudio';
        break;
      case 'CONTENT_FOLDER':
        circleColor = _color["default"].disabled;
        contentIcon = 'solidFolder';
        break;
      case 'CONTENT_DOCX':
        circleColor = _color["default"].blue;
        contentIcon = 'fileWord';
        break;
      case 'CONTENT_XLSX':
        circleColor = _color["default"].success;
        contentIcon = 'fileExcel';
        break;
      case 'CONTENT_PPTX':
        circleColor = _color["default"].orange;
        contentIcon = 'filePowerpoint';
        break;
      case 'CONTENT_EVENT':
        circleColor = _color["default"].orange;
        contentIcon = 'event';
        break;
    }
  }
  return {
    circleColor: circleColor,
    contentIcon: contentIcon
  };
};
exports.getContentIconColor = getContentIconColor;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(getContentIconColor, "getContentIconColor", "/Users/crs/WebstormProjects/michelangelo/src/Components/helpers/color-helper.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();